var allowed_keys = [
    'us_mens',
    'us_womens',
    'ball_girth_cm',
    'ball_girth_in',
    'length_cm',
    'length_in',
    'size',
    'size_in_cm',
    'thigh_circumference_inch',
    'calf_circumference_inch',
    'shaft_height_inch',
    'shoelace_length_in'
  ],   
      meta_rename_obj = {
        'us_mens': "US MEN'S",
        'us_womens': "US WOMEN'S",
        'ball_girth_cm': 'BALL GIRTH (CM)',
        'ball_girth_in': 'BALL GIRTH (IN)',
        'length_cm': 'LENGTH (CM)',
        'length_in': 'LENGTH (IN)',
        'size': 'SIZE',
        'size_in_cm': 'SIZE (CM)',
        'calf_circumference_inch':'CALF CIRC. (IN)',
        'calf_circumference_cm':'CALF CIRC. (CM)',
        'thigh_circumference_inch':'THIGH CIRC. (IN)',
        'thigh_circumference_cm':'THIGH CIRC. (CM)',
        'shaft_height_inch':'SHAFT HEIGHT (IN)',
        'shaft_height_cm':'SHAFT HEIGHT (CM)',
        'shoelace_length_in': 'SHOELACE LENGTH (IN)'
      },
      mytable = document.createElement('table'),
      thead = document.createElement('thead'),
      thead_tr = document.createElement('tr'),
      tbody = document.createElement('tbody'),
      new_meta_obj = {};
      
  mytable.id = "size-chart";
  mytable.className = "table table-striped";
  mytable.appendChild(thead);
  thead.appendChild(thead_tr);
  mytable.appendChild(tbody);
  
  var tabsS2 = document.getElementById("tabs-s2");
  if (tabsS2) {
    tabsS2.appendChild(mytable);
  }
    var isFr = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  if (isFr) {
    meta_rename_obj = {
      'us_mens': 'POINTURE US HOMMES',
      'us_womens': 'POINTURE US FEMMES',
      'ball_girth_cm': 'TOUR AVANT-PIED (CM)',
      'ball_girth_in': 'TOUR AVANT-PIED (PO)',
      'length_cm': 'LONGUEUR (CM)',
      'length_in': 'LONGUEUR (PO)',
      'size': 'POINTURE',
      'size_in_cm': 'POINTURE (CM)',
      'calf_circumference_inch': 'TOUR DE MOLLET (PO)',
      'calf_circumference_cm': 'TOUR DE MOLLET (CM)',
      'thigh_circumference_inch': 'TOUR DE CUISSE (PO)',
      'thigh_circumference_cm': 'TOUR DE CUISSE (CM)',
      'shaft_height_inch': 'HAUTEUR DE TIGE (PO)',
      'shaft_height_cm': 'HAUTEUR DE TIGE (CM)',
      'shoelace_length_in': 'LONGUEUR DES LACETS (PO)'
    };
  }
  allowed_keys.forEach(function(key, i) {
    if (key in metafields) {
      var arr = metafields[key].split(',');
      new_meta_obj[key] = arr.sort(function(a, b) {
        return parseFloat(a) - parseFloat(b);
      });
      
      var thead_name = (meta_rename_obj[key] ? meta_rename_obj[key] : key.replace(/_/g,' ').toUpperCase());
      var th = document.createElement('th');
      th.textContent = thead_name;
      thead_tr.appendChild(th);
    }
  });
  
  var driver = new_meta_obj.size || new_meta_obj.us_mens || new_meta_obj.us_womens;
  var sizes = {};
  if (driver) {
    driver.forEach(function(el, i) {
      if (!(el in sizes) && el != '') {
        sizes[el] = i;
        var row = document.createElement('tr');
        tbody.appendChild(row);
        
        for (var key in new_meta_obj) {
          if (new_meta_obj[key].length > 0) {
            var cols = new_meta_obj[key],
                td_txt = (!cols[i] || cols[i] == '' ? '' : cols[i]);
            var td = document.createElement('td');
            td.textContent = td_txt;
            row.appendChild(td);
          }
        }
      }
    });
  }
  
  var sizeTable = document.getElementById("size-table");
  if (mytable && sizeTable) {
    sizeTable.appendChild(mytable);
  }	 